import React from "react";
import { Instagram, Youtube, AtSign } from "lucide-react";

const PLATFORMS = ["Apple Podcasts", "Spotify", "YouTube Music", "Amazon Music", "Overcast"];

export const Footer = () => {
    return (
        <footer data-testid="site-footer" className="relative pt-20 pb-32 border-t border-border bg-[#F4ECF7]">
            <div className="mx-auto max-w-7xl px-6 md:px-10">
                <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-10">
                    <div>
                        <div className="flex items-center gap-3">
                            <span className="grid place-items-center w-10 h-10 rounded-full bg-gold text-white font-display text-lg">
                                H
                            </span>
                            <span className="font-display text-2xl text-lilac-900">
                                Becoming <span className="italic">H.E.R.</span>
                            </span>
                        </div>
                        <p className="mt-4 max-w-sm text-sm text-lilac-700 leading-relaxed">
                            A spiritually-rooted podcast for women breaking cycles and walking in Godly
                            alignment. New episodes every Tuesday.
                        </p>
                    </div>

                    <div className="flex flex-col items-start md:items-end gap-4">
                        <div className="eyebrow text-lilac-700">Listen on</div>
                        <div className="flex flex-wrap gap-2">
                            {PLATFORMS.map((p) => (
                                <span
                                    key={p}
                                    className="px-4 py-2 rounded-full border border-border text-xs text-lilac-900 bg-white hover:bg-lilac-50 transition-colors"
                                >
                                    {p}
                                </span>
                            ))}
                        </div>
                    </div>
                </div>

                <div className="mt-16 pt-8 border-t border-border flex flex-col md:flex-row md:items-center md:justify-between gap-4">
                    <p className="text-xs text-lilac-700">
                        © {new Date().getFullYear()} Becoming H.E.R. — Made with reverence.
                    </p>
                    <div className="flex items-center gap-3">
                        {[
                            { Icon: Instagram, label: "Instagram" },
                            { Icon: Youtube, label: "YouTube" },
                            { Icon: AtSign, label: "Threads" },
                        ].map(({ Icon, label }) => (
                            <a
                                key={label}
                                href="#"
                                aria-label={label}
                                data-testid={`social-${label.toLowerCase()}`}
                                className="grid place-items-center w-9 h-9 rounded-full border border-border text-lilac-900 hover:bg-gold hover:text-white hover:border-gold transition-colors"
                            >
                                <Icon className="w-4 h-4" />
                            </a>
                        ))}
                    </div>
                </div>
            </div>
        </footer>
    );
};
